import * as MXPixel from "../MXPixel/MedexpressPixel";
import DomFactory from "../Utils/DomFactory";
import ProductState from "./ProductState";
import Events from "../Utils/Events";
import ProductPageState from "./ProductPageState";
import { getAnalyticsInfo } from "./Analytics";
import * as Util from "../Utils/Util";

declare let medexpress: any;

export default class BuyButton {
  private readonly containerElement: HTMLElement;
  private readonly buttonElement: HTMLAnchorElement;
  private readonly strengthCode: string | undefined;
  private readonly productCode: string | undefined;
  private readonly isCompliantFlow: boolean;
  private readonly categoryUrl: string;
  private readonly preConsultationUrl: string | undefined;

  public constructor(element: HTMLElement) {
    this.containerElement = element;
    this.buttonElement = BuyButton.getButton(element);
    this.strengthCode = Util.getNullableData(element, "strengthCode");
    this.productCode = Util.getNullableData(element, "productCode");
    this.isCompliantFlow = JSON.parse(Util.getData(element, "isCompliantFlow"));
    this.categoryUrl = Util.getData(element, "categoryUrl");
    this.preConsultationUrl = Util.getNullableData(element, "preConsultationUrl");
    Events.on("product-state-change", (s: ProductState) => this.updateUrl(s));
    Events.fire("product-state-change-request", this);
    this.setupAnalytics();
  }

  private setupAnalytics() {
    const info = getAnalyticsInfo();
    this.buttonElement.addEventListener("click", () => {
      const state = ProductPageState.getInstance().getCurrentState();

      const mxPixel = medexpress.MedexpressPixel as typeof MXPixel;

      const boCode: string = this.buildCode(state);

      mxPixel.addUserProperties({
        last_selected_product: boCode,
        last_selected_quantity: state.quantity.code,
        last_selected_frequency: state.frequency?.code || "ONE_TIME",
      });

      mxPixel.amplitudeEvent("Click Start Consultation", {
        Medicine: info.medicine,
        Treatment: info.treatment,
      });
    });
  }

  private updateUrl(state: ProductState): void {
    if (this.isCompliantFlow) {
      this.buttonElement.href = `${this.preConsultationUrl ?? this.categoryUrl}?product_code=${this.buildCode(
        state
      )}&quantity=${state.quantity.code}`;
    } else {
      this.buttonElement.href =
        "/consultations/questions/" + this.buildCode(state) + "?quantity=" + state.quantity.code;
    }
  }

  private buildCode(state: ProductState): string {
    let code: string = state.product.code;
    switch (state.product.actionButtonType) {
      case "DEFAULT":
        code = code.concat(state.strength.code);
        break;
      case "FIXED_STRENGTH":
        if (this.strengthCode != null) {
          code = code.concat(this.strengthCode);
        }
        break;
      case "FIXED_NO_STRENGTH":
      default:
        break;
    }

    return code;
  }

  private static getButton(element: HTMLElement): HTMLAnchorElement {
    return <HTMLAnchorElement>element.querySelector("a")!;
  }

  public static Factory: DomFactory<BuyButton> = (e) => new BuyButton(e);
}
